import { getClerkInstance } from "./clerkAuth";

export const authGuard = async (to, from, next) => {
  const auth = getClerkInstance();
  if (!auth) return next({ path: "/" });
  try {
    await auth.init();
    if (!auth.isAuthenticated) return next({ path: "/" });
    if (!auth.subscriptionChecked) await auth.refreshSubscription();
    if (auth.subscriptionValid && auth.isSubscriptionActive()) return next();
    return next({ path: "/pricing" });
  } catch (error) {
    // A failed or pending request is not evidence that payment is required.
    return next({ path: "/dashboard", query: { subscription: "retry" } });
  }
};

export const authOnlyGuard = (to, from, next) => {
  const auth = getClerkInstance();
  if (!auth) return next({ path: "/" });

  if (auth.loading) {
    let resolved = false;
    const unwatch = auth.$watch("loading", (val) => {
      if (!val && !resolved) {
        resolved = true;
        unwatch();
        if (auth.isAuthenticated) return next();
        return next({ path: "/" });
      }
    });
    setTimeout(() => {
      if (!resolved) {
        resolved = true;
        try { unwatch(); } catch (e) {}
        if (auth.isAuthenticated) return next();
        return next({ path: "/" });
      }
    }, 5000);
    return;
  }

  if (auth.isAuthenticated) return next();
  return next({ path: "/" });
};

export const adminGuard = async (to, from, next) => {
  const auth = getClerkInstance();
  if (!auth) return next({ path: "/" });

  // Wait for Clerk to be fully loaded
  if (auth.loading) {
    let resolved = false;
    const unwatch = auth.$watch("loading", async (val) => {
      if (!val && !resolved) {
        resolved = true;
        unwatch();
        await _checkAdmin(auth, next);
      }
    });
    setTimeout(async () => {
      if (!resolved) {
        resolved = true;
        try { unwatch(); } catch (e) {}
        await _checkAdmin(auth, next);
      }
    }, 10000); // Increased timeout for slower connections
    return;
  }

  await _checkAdmin(auth, next);
};

async function _checkAdmin(auth, next) {
  if (!auth.isAuthenticated) return next({ path: "/" });
  
  try {
    const metadata = await auth.getPublicMetadata();
    if (metadata.role === 'admin') {
      return next();
    } else {
      console.warn('[AdminGuard] User is not an admin');
      return next({ path: "/dashboard" });
    }
  } catch (error) {
    console.error('[AdminGuard] Error checking admin role:', error);
    return next({ path: "/dashboard" });
  }
}
